/*eslint-disable*/
import {mapState} from 'vuex'

export default {
    data () {
        return {
            digitCapacityNames: {
                1: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                2: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                3: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                4: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                5: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                6: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                7: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                8: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
            },
            modeNames: {
                "abacus": this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                "mind": this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                "any": this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                "allTogether": this.$i18n.t('couples.couples_gameMode_allTogether'),
                "inTurn": this.$i18n.t('couples.couples_gameMode_inTurn'),
                "На счетах": this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                "В уме": this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                "Любой": this.$i18n.t('trainer.trainer_gameFormSettingValue_any')
            },
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            puzzleGame: state => state.games.puzzle
        }),
        settings () {
            let userId = this.userId;
            let slugForComparing = this.game ? this.game.slug : this.parameters.slug;
            if (this.puzzleGame && this.puzzleGame.games[0].slug === slugForComparing) {
                userId = this.user.id;
            }
            if (this.game) {
                for (let key in this.game.parameters) {
                    if (key !== 'default' && key.match(/[\d]*[\d]+/g).some(item => +item === userId)) {
                        return this.game.parameters[key];
                    }
                }
                return this.game.parameters.default
            }
            return this.parameters
        }
    },
    methods: {
        getDifficultName (index) {
            return this.digitCapacityNames[index];
        },
        getModeName (index) {
            return this.modeNames[index] ? this.modeNames[index] : index;
        }
    }
}
